import { render } from "./PantryDetailGuideDialog.vue?vue&type=template&id=0b8d9e40&ts=true"
import script from "./PantryDetailGuideDialog.vue?vue&type=script&lang=ts"
export * from "./PantryDetailGuideDialog.vue?vue&type=script&lang=ts"

import "./PantryDetailGuideDialog.vue?vue&type=style&index=0&id=0b8d9e40&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__